import _ from 'lodash';
import { createApiReducer, chainReducers, INITIAL_API_STATE } from 'src/api';
import { transformFI } from 'src/financial-institution/redux/reducers';

import {
  FETCH_ACCOUNTS_START,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  UPDATE_ACCOUNT_STATUS_START,
  UPDATE_ACCOUNT_STATUS_SUCCESS,
  UPDATE_ACCOUNT_STATUS_FAILURE,
} from './actions';

import {
  SEND_ACCOUNT_INVITE_START,
  SEND_ACCOUNT_INVITE_SUCCESS,
  SEND_ACCOUNT_INVITE_FAILURE,
  DELETE_ACCOUNT_START,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
} from '../account/actions';
import { transformDBA } from '../account/dba';

export const transformAccount = response => {
  let financialInstitution =
    response.financial_institution_account_financial_institution;
  if (financialInstitution) {
    financialInstitution = transformFI(financialInstitution);
  }
  return {
    id: response.financial_institution_account_account,
    businessName: response.financial_institution_account_business_name,
    dbas: response.financial_institution_account_dbas.map(transformDBA),
    status: response.financial_institution_account_status,
    ownerName: response.financial_institution_account_owner_name,
    initiated: response.financial_institution_account_initiated,
    hasPayments: response.financial_institution_account_for_payments,
    hasLending: response.financial_institution_account_for_lending,
    hasConsents: response.has_consents,
    hasLoans: response.has_loans,
    hasObligations: response.has_obligations,
    hasDocuments: response.has_documents,
    sent_to_base: response.sent_to_base,
    base_Id: response.base_Id,
    financialInstitution,
    primaryAgents: response.financial_institution_account_agents
      .filter(a => a.agent_role === 'Primary Agent')
      .map(x => x.agent_user),
    secondaryAgents: response.financial_institution_account_agents
      .filter(a => a.agent_role === 'Secondary Agent')
      .map(x => x.agent_user),
  };
};

const transformAccounts = response => {
  return {
    items: response.map(transformAccount),
  };
};

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountsGetReducer = createApiReducer(
  [FETCH_ACCOUNTS_START, FETCH_ACCOUNTS_SUCCESS, FETCH_ACCOUNTS_FAILURE],
  transformAccounts,
  error => _.get(error, 'payload.response', 'unknown error')
);

const accountsDeleteReducer = createApiReducer(
  [DELETE_ACCOUNT_START, DELETE_ACCOUNT_SUCCESS, DELETE_ACCOUNT_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      items: state.data.items.filter(
        a => a.id !== payload.financial_institution_account_account
      ),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

const accountsAddReducer = createApiReducer(
  [
    SEND_ACCOUNT_INVITE_START,
    SEND_ACCOUNT_INVITE_SUCCESS,
    SEND_ACCOUNT_INVITE_FAILURE,
  ],
  (payload, state) => {
    const oldAccounts = state.data.items || [];

    return {
      ...state.data,
      items: [...oldAccounts, transformAccount(payload)],
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

const accountsUpdateReducer = createApiReducer(
  [
    UPDATE_ACCOUNT_STATUS_START,
    UPDATE_ACCOUNT_STATUS_SUCCESS,
    UPDATE_ACCOUNT_STATUS_FAILURE,
  ],
  (payload, state) => {
    const newAccount = transformAccount(payload);

    return {
      ...state.data,
      items: state.data.items
        ? updateItem(state.data.items, 'id', newAccount.id, newAccount)
        : undefined,
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

export const accounts = chainReducers(
  INITIAL_API_STATE,
  accountsGetReducer,
  accountsDeleteReducer,
  accountsAddReducer,
  accountsUpdateReducer
);
